export const dialogSize = {
  MEDIUM: '480px'
};
